module.exports = "https://www.gc-qa.gnp.com.mx/be5da7c8e8e2bf252ea2cc5547615f70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/user1.svg
// module id = 699
// module chunks = 0